import { RepositoryFactory } from '../../repositories/RepositoryFactory'
const libraryRepository = RepositoryFactory.get('library')

const defaultState = () => ({
  items: [],
  length: 0,
  paged: 0,
})

const state = defaultState()

const getters = {}

const mutations = {
  incrementPage(state) {
    state.paged++
  },
  setItems(state, payload) {
    state.length = payload.length
    state.items = state.items.concat(payload)
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ state, commit }, { perPage }) {
    try {
      const { succeed, reportArticles } = await libraryRepository.getNew(
        state.paged * perPage,
        perPage
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', reportArticles)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
